"use client"

import DtvLinkFarm from "@directv-digital/dds.ui.linkfarm";

export default function GlobalLinkFarm(props){
  return <DtvLinkFarm {...props} />
}
